import { Injectable } from "@angular/core";

@Injectable({providedIn:'root'})
export class NearbyParticipantService {

}

export enum ParticipantsPageMode {
    DEFAULT,
    LOCATION_EXPORT
} 